import React from 'react'

const FrenquentlyAsked = () => {
  return (
    <section className='lg:mx-40 mt-40'>
      <div className='max-w-screen-xl mx-auto'>
        <h2 className='text-center font-tiempo text-azul font-semibold mx-12 text-5xl'>Frequently Asked Questions</h2>
        <p className='font-basis text-gray-1 text-center mx-8 mb-4 sm:mx-24  py-4 '>Below you'll find answers to some common questions around creating a custom box. Every order is little different though, so don't hesitate to reach out with anything else you might be wondering.</p>
      </div>
      <div className='faq max-w-screen-lg'>
        <div className='mb-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            Can I get an instant quote for my order?
          </h4>
          <p className='text-gray-1 text-lg'>
            Yes, you can select your size, material, and quantity on our free 3D design tool to instantly view a quote for your project. As you upload artwork, add text, or color the background in each panel of the 3D model, you'll see your Unit Price update in real-time.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            What packaging products can I order from Packlane?
          </h4>
          <p className='text-gray-1 text-lg'>
            At Packlane, we offer a variety of packages for you to choose from and customize. Our custom packaging boxes include Shipping Boxes, Mailer Boxes, and Product Boxes. They can be ordered in both stock and custom sizes at low minimums. These box styles are perfect for either retail packaging or ecommerce deliveries. Our Mailer Box and Shipping Box cardboard products are safe to mail, while our Product Box packages are intended for display (or to be placed within a shipping-safe box when sent out for delivery). Get started with our easy-to-use box designer and create custom printed packaging boxes for your brand today.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            What if I'm designing in Adobe Illustrator?
          </h4>
          <p className='text-gray-1 text-lg'>
            If you're building your design on one of our Illustrator templates, you can submit your file on our Dieline Upload tool and a quote for your project will be sent to you ASAP. You can also email your dieline to our customer support team and we'll send you back a quote. If you do not have packaging artwork for your box yet, you can get a rough quote by applying a solid color on any panels of our 3D design tool where you will want your design printed.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            How does your 3D box designer work?
          </h4>
          <p className='text-gray-1 text-lg'>
            If you have individual artwork elements such as logos, images or text, you can customize your box specifications directly on our 3D design tool and receive pricing on that same page. As you build your design on the 3D box model, you will see your Unit Price update in real-time to reflect any changes that affect your project's pricing. Once you have finalized your design, you can proceed directly to checkout, save your design for later, or even share your design with friends or colleagues!
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            What is the turnaround time on my order?
          </h4>
          <p className='text-gray-1 text-lg'>
            Our Standard turnaround for most custom packaging orders is around 10 business days and Rush turnaround is 7 business days. These turnarounds do not include transit time (1 - 7 business days depending on your location). Special custom or bulk orders may require a few extra days to get setup and produced. Please note that during extremely busy times of year some orders may take longer to complete. While delivery estimates cannot be guaranteed, all dates shown at checkout are the quickest estimate we offer. If your delivery date is time sensitive, we highly recommend choosing Rush production and expedited shipping for your box orders.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            What happens after I place my order? Do I get a proof before printing?
          </h4>
          <p className='text-gray-1 text-lg'>
            After checkout, our dedicated Prepress team will review your design for any technical concerns and send a 2D digital proof of your custom boxes to your email within 24 hours. If any changes need to be made, you can send a note directly to our Prepress team through the proof page and they'll be happy to help with finalizing your design for printing.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            Will I see a proof for my order?
          </h4>
          <p className='text-gray-1 text-lg'>
            All new orders will receive a digital proof within 24 hours of completing the checkout process.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            How do I know if my art is printable?
          </h4>
          <p className='text-gray-1 text-lg'>
            Our dedicated in-house Prepress team will review your custom box design for any technical concerns (artwork resolution, blurriness, splits, thin lines, and bleeds) and if found, will note them for your attention in the proof. If you're unsure of how to fix any printing concerns that are noted, our Prepress representatives are happy to help you through the process. It's important to keep in mind that our team does not check for spelling or grammar errors, nor do they provide any subjective feedback on design content.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            Can you print inside the boxes?
          </h4>
          <p className='text-gray-1 text-lg'>
            Yes! We can print on the inside of any of our corrugated box styles. This includes Mailers, Shipping Boxes, and Tuck Tops (our secret menu product!). Product Boxes are currently limited to printing on the exterior only. You can even use our online box designer to design the inside of your custom boxes. For Shippers and Tuck Tops, we currently require a 2D dieline template be submitted for both the interior and exterior so we can set up your order as a custom order. You can also submit designs this way for our Mailer boxes, if you prefer to build on a 2D Illustrator template instead of our free 3D box design tool.
          </p>
        </div>
        <div className='my-8 mx-4'>
          <h4 className='text-azul font-semibold text-xl mb-2'>
            What choices affect my pricing?
          </h4>
          <p className='text-gray-1 text-lg'>
            As a high-volume producer with scale economies, Packlane provides the industry's most competitive prices on custom printed boxes available. Pricing is generally a factor of five things: dimensions, box style, ink coverage on the box, box material, and quantity (higher quantities = bulk savings). Custom orders of 5,000 or more can be eligible for volume discounts. If you have questions about pricing or choices that can affect your custom packaging order, our customer support team is happy to help!
          </p>
        </div>
      </div>
    </section>
  )
}

export default FrenquentlyAsked
